import BaseEntity from '../../base/BaseEntity.model';
import Direccion from '@/models/direccion.model';

export default class TramiteCambioDireccion extends BaseEntity {
    public tramiteBeneficiarioId?: number;
    public personaId?: number;
    public direccion?: Direccion;
    constructor(public direccionId: number|undefined = undefined) {
        super();
        this.tramiteBeneficiarioId = undefined;
        this.personaId = undefined;
        this.direccion = undefined;
    }
}